export const encodeForm = (object) => {
    var str = [];
    for (var p in object) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(object[p]));
    }
    return str.join("&");
};


